<template>
  <Header class="ccindex-header">
    <Menu mode="horizontal" theme="dark" active-name="1">
      <div class="layout-logo">
        263网络会议4.0
      </div>
      <div class="layout-nav">
        <MenuItem name="1">
          <router-link tag="li" to="/">
            <Icon type="md-videocam" />
            会议
          </router-link>
        </MenuItem>
        <MenuItem name="2">
          <router-link tag="li" to="/historymsg">
            <Icon type="md-notifications" />
            历史消息
          </router-link>
        </MenuItem>
        <MenuItem name="3">
          <router-link tag="li" to="/addressbook">
            <Icon type="ios-paper" />
            通讯录
          </router-link>
        </MenuItem>
        <MenuItem name="4">
          <router-link tag="li" to="/setting">
            <Icon type="ios-settings" />
            我的设置
          </router-link>
        </MenuItem>
        <MenuItem name="5"  style="width: 100px;overflow: hidden">
          {{this.userInfo.name}}
        </MenuItem>
        <MenuItem name="5">
          退出
        </MenuItem>
      </div>
    </Menu>
  </Header>
</template>
<script>
    export default {
        name: "myhead",
        data(){
          return{
            userInfo:{name:''}
          }
        },
        created(){
           this.init();
        },
        methods:{
           init(){
              if(JSON.parse(localStorage.getItem('userInfo'))){
                 this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
              }
           }
        }
    }
</script>
<style scoped>
  .ivu-layout-header{background: #fff}
  .ivu-layout-header .ivu-menu-dark{background: #fff}
  .ivu-layout-header .ivu-menu-dark.ivu-menu-horizontal .ivu-menu-item{color:#0077d7;}
  .ccindex-header  .layout{
    border: 1px solid #d7dde4;
    background: #f5f7f9;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
  }
  .ccindex-header .layout-logo{
    float: left;
    position: relative;
    left: 20px;
    font-size:22px;
  }
  .ccindex-header .layout-nav{
    width: 620px;
    margin: 0 auto;
    margin-right: 20px;
  }
  .ccindex-header .layout-footer-center{
    text-align: center;
  }
</style>
